import { reduce, isEqual } from 'lodash';

export function objectDifference(obj1: object, obj2: object){
	return reduce(obj1, function(result, value, key) {
		return isEqual(value, obj2[key]) ?
		result : result.concat(key);
	}, []);
}